import ObjectId from "bson-objectid";
import { updateLevel2Properties } from "../../../features/reduxworkbook/WorkbookSlice";
import { columIdIncludes } from "../Utils/ChartsFunctions";

const handleHeaderSort = (
  headerItem,
  isColumnPresent,
  sortArray,
  rowKeys,
  valueKeys,
  dispatch,
  Sheetid
) => {
  const headerCondition = columIdIncludes(headerItem); // returns pipe, total, underscore, or none

  let requiredSortObject;

  const existingSort = sortArray.find(
    (sortItem) => sortItem.responseKey === headerItem.columnId
  );

  // Toggle sort order
  const newSortOrder = existingSort
    ? existingSort.order === "ASC"
      ? "DESC"
      : "ASC"
    : "DESC";

  // // console.log(newSortOrder);
  // console.log(headerItem);
  // console.log(headerCondition);
  // // console.log(valueKeys);

  switch (headerCondition) {
    case "none": {
      // Handle the case when columnId includes nothing
      const matchingRowKey = rowKeys.find(
        (row) => row.responseKey === headerItem.caption
      );
      // console.log(matchingRowKey);

      if (!matchingRowKey) {
        console.error("No matching row key found");
        return; // Early return if no matching row key
      }
      requiredSortObject = {
        column: headerItem.columnId,
        dataType: matchingRowKey.dataType || null,
        _id: matchingRowKey._id || null,
        order: newSortOrder,
        customOrder: [],
        columnId: matchingRowKey ? matchingRowKey.nanoId : "rows",
        yearType: matchingRowKey.yearType,
        responseKey: headerItem.columnId,
      };
      if (matchingRowKey.dataType === "Date") {
        // console.log("ji");
        requiredSortObject = {
          ...requiredSortObject,
          column: `${matchingRowKey.columnName}${matchingRowKey.dateFormat.value}`,
          format: matchingRowKey.format,
        };
      }
      break;
    }
    case "underscore": {
      // Handle columnId includes "_"
      const matchingValueKey = valueKeys.find(
        (row) => row.responseKey === headerItem.caption
      );
      requiredSortObject = {
        column: headerItem.columnId,
        dataType: "Number",
        _id: new ObjectId().toHexString(),
        order: newSortOrder,
        format: null,
        customOrder: [],
        columnId: matchingValueKey ? matchingValueKey.nanoId : "groupByFields",
        responseKey: headerItem.columnId,
      };
      break;
    }
    case "pipe": {
      // Handle columnId includes "|"
      requiredSortObject = {
        column: headerItem.columnId,
        dataType: "Number",
        _id: new ObjectId().toHexString(),
        order: newSortOrder,
        format: null,
        customOrder: [],
        columnId: "groupByFields",
        responseKey: headerItem.columnId,
      };
      break;
    }
    case "total": {
      // Handle columnId includes "Total"
      if (isColumnPresent) {
        requiredSortObject = {
          column: headerItem.columnId,
          dataType: "Number",
          _id: new ObjectId().toHexString(),
          order: newSortOrder,
          format: null,
          customOrder: [],
          columnId: "groupByFields",
          responseKey: headerItem.columnId,
        };
      }
      break;
    }

    default:
      console.error("Unexpected header condition");
      return;
  }

  if (!requiredSortObject) {
    console.error("Required sort object is undefined");
  } else {
    // console.log(requiredSortObject);
    // Dispatch the updated sort properties
    dispatch(
      updateLevel2Properties({
        reduxKey: "sort",
        Sheetid,
        parentKey: "actions",
        value: [requiredSortObject],
        itemInArray: false,
        index: null,
      })
    );
  }
};
export { handleHeaderSort };
